export default "__VITE_ASSET__ASU6lJTQ__"